export default {
    props: {
        totalSlides: Number,
        slideInterval: Number,
    },
    swiper: null,
    data: () => ({
        active: 0,
    }),
    computed: {
        showNavigation() {
            return this.totalSlides > 1;
        },
        isActive() {
            return ({ index }) => index === this.active;
        },
        options() {
            return {
                allowSlidePrev: this.showNavigation,
                allowSlideNext: this.showNavigation,
                loop: true,
                autoplay: !this.showNavigation ? false : {
                    delay: (this.slideInterval * 1000),
                },
            };
        },
    },
    render() {
        return this.$scopedSlots.default({
            active: this.active,
            changeSlide: this.changeSlide,
            isActive: this.isActive,
            options: this.options,
            registerSwiper: this.registerSwiper,
        });
    },
    methods: {
        changeSlide({ index }) {
            this.$options.swiper.slideTo(index + 1);
        },
        registerSwiper({ component }) {
            this.$options.swiper = component.swiper;

            this.$options.swiper.on('slideChange', () => {
                this.active = this.$options.swiper.realIndex;
            });
        },
    },
};
